import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { IDropdownOption } from '../../../shared/typings/interfaces/design-library.interface';

@Component({
  selector: 'network-settings-mad-lib',
  template: require('./network-settings-mad-lib.component.html'),
  styles: [require('./network-settings-mad-lib.component.scss')],
})
export class NetworkSettingsMadLibComponent {
  @Input() option$: Observable<IDropdownOption[]>;
  @Input() optionSelected: string;
  @Output() madLibChange = new EventEmitter();

  public emitMadLibChange(e: string): void {
    if (this.optionSelected !== e) {
      this.madLibChange.emit(e);
    }
  }
}
